export default __webpack_public_path__ + "static/media/stonewell_logo_KO.744041f4.png";